// frontend/src/components/client/ClientDashboardHome.jsx
import React, { useState, useEffect } from 'react';
import { Fuel, Plane, MapPin, Navigation } from 'lucide-react';
import { getDashboardStats, getMyAircraft, getFuelRequests } from '../../services/clientApi';
import ClientStatsCards from './ClientStatsCards';
import FlightPlanCanvas from './FlightPlanCanvas';
import FuelRequestCard from './FuelRequestCard';
import FuelRequestDrawer from './FuelRequestDrawer';

const ClientDashboardHome = ({ onNavigateToFuel }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pendingFuelRequests, setPendingFuelRequests] = useState([]);
  const [aircraftList, setAircraftList] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedAircraft, setSelectedAircraft] = useState(null);
  
  // Récupérer l'home base du premier avion (ou du client)
  const userHomeBase = aircraftList[0]?.home_base || null;

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    setLoading(true);
    try {
      const [statsRes, aircraftRes, fuelRes] = await Promise.all([
        getDashboardStats(),
        getMyAircraft(),
        getFuelRequests('pending')
      ]);
      
      setStats(statsRes.data);
      setAircraftList(aircraftRes.data);
      setPendingFuelRequests(fuelRes.data || []);
    } catch (error) {
      console.error('Error loading dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  const openFuelDrawer = (request) => {
    const aircraft = aircraftList.find(a => a.id === request.aircraft_id);
    if (aircraft) {
      setSelectedAircraft(aircraft);
      setSelectedRequest(request);
    }
  };

  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <ClientStatsCards stats={stats} loading={loading} onRefresh={loadDashboardData} />
      
      {/* Flight Plan Canvas */}
      {userHomeBase && (
        <FlightPlanCanvas 
          departureIcao={userHomeBase}
          onPlanClick={onNavigateToFuel}
        />
      )}
      
      {/* Pending Fuel Requests */}
      <div>
        <h3 className="text-white font-semibold mb-3 flex items-center gap-2">
          <Fuel className="w-4 h-4 text-orange-400" />
          Pending Fuel Requests
        </h3>
        {pendingFuelRequests.length === 0 ? (
          <div className="bg-gray-800/30 rounded-xl border border-gray-700 p-6 text-center">
            <p className="text-gray-500 text-sm">No pending fuel requests</p>
            <button 
              onClick={onNavigateToFuel}
              className="mt-2 text-blue-400 text-sm hover:text-blue-300"
            >
              Create a fuel request →
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {pendingFuelRequests.map(req => (
              <FuelRequestCard 
                key={req.id}
                request={req}
                onClick={() => openFuelDrawer(req)}
              />
            ))}
          </div>
        )}
      </div>

      {/* Drawer */}
      {selectedRequest && selectedAircraft && (
        <FuelRequestDrawer
          request={selectedRequest}
          aircraft={selectedAircraft}
          onClose={() => {
            setSelectedRequest(null);
            setSelectedAircraft(null);
            loadDashboardData();
          }}
          onRefresh={loadDashboardData}
        />
      )}
    </div>
  );
};

export default ClientDashboardHome;